export default "__VITE_ASSET__Dgohwt84__"